import React from 'react';
import { ClipboardListIcon, HandCoinsIcon, CalendarCheck2Icon, ArrowRightIcon } from 'lucide-react';
export function HowItWorks() {
  return <section className="py-20 md:py-28 px-6 md:px-12 lg:px-16" data-id="element-185">
      <div className="max-w-6xl mx-auto" data-id="element-186">
        <div className="text-center mb-16" data-id="element-187">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B2A4A] mb-6 tracking-tight" data-id="element-188">
            How It Works
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-189">
            Selling your house doesn't have to be complicated. Our simple 3-step
            process gets you cash fast.
          </p>
        </div>

        <div className="relative" data-id="element-190">
          {/* Connecting Line (Desktop) - Tighter gap */}
          <div className="hidden md:block absolute top-[28px] left-[18%] right-[18%] h-px bg-slate-200 -z-10" data-id="element-191" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-192">
            {/* Step 1 */}
            <div className="relative flex flex-col items-center text-center md:items-start md:text-left group animate-fade-in-up delay-100" data-id="element-193">
              <div className="w-14 h-14 bg-white border-2 border-[#E8913A] rounded-full flex items-center justify-center mb-5 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-194">
                <ClipboardListIcon className="w-6 h-6 text-[#E8913A]" data-id="element-195" />
              </div>
              <div className="text-[10px] font-bold text-[#E8913A] uppercase tracking-widest mb-2 opacity-80" data-id="element-196">
                Step 01
              </div>
              <h3 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-197">
                Submit Your Property Info
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-198">
                Fill out our short form or give us a call. Tell us a bit about
                your property and your situation.
              </p>
            </div>

            {/* Step 2 */}
            <div className="relative flex flex-col items-center text-center md:items-start md:text-left group animate-fade-in-up delay-200" data-id="element-199">
              <div className="w-14 h-14 bg-white border-2 border-[#E8913A] rounded-full flex items-center justify-center mb-5 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-200">
                <HandCoinsIcon className="w-6 h-6 text-[#E8913A]" data-id="element-201" />
              </div>
              <div className="text-[10px] font-bold text-[#E8913A] uppercase tracking-widest mb-2 opacity-80" data-id="element-202">
                Step 02
              </div>
              <h3 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-203">
                Get Your Cash Offer
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-204">
                We'll review the details and present you with a fair,
                no-obligation cash offer within 24 hours.
              </p>
            </div>

            {/* Step 3 */}
            <div className="relative flex flex-col items-center text-center md:items-start md:text-left group animate-fade-in-up delay-300" data-id="element-205">
              <div className="w-14 h-14 bg-white border-2 border-[#E8913A] rounded-full flex items-center justify-center mb-5 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-206">
                <CalendarCheck2Icon className="w-6 h-6 text-[#E8913A]" data-id="element-207" />
              </div>
              <div className="text-[10px] font-bold text-[#E8913A] uppercase tracking-widest mb-2 opacity-80" data-id="element-208">
                Step 03
              </div>
              <h3 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-209">
                Close &amp; Get Paid
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-210">
                You pick the day we close. We handle all the paperwork, and you
                walk away with cash in hand.
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16 text-center" data-id="element-211">
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} className="inline-flex items-center bg-[#1B2A4A] hover:bg-[#152238] text-white font-bold py-4 px-8 rounded-md transition-colors group text-lg shadow-md" data-id="element-212">
            Request Your Offer
            <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-213" />
          </button>
        </div>
      </div>
    </section>;
}